module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-bold-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-bold-webfont.svg
// module id = 138
// module chunks = 3